<template>
  <layout-content>
    <template #toolbar>
      <span style="font-size:1em;color:#606266"> 查询期间： </span>
      <el-select v-model="value" size="small" style="width:80px;" @change="choiceChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <data-time-query :query="query" />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="getData"
      >查询</el-button>
      <el-button
        :disabled="canNotSearch"
        type="success"
        size="small"
        icon="el-icon-download"
        @click="onDownloadBtnClick"
      >导出</el-button>
    </template>

    <template #body>
      <data-wrapper>
        <template #header>
          <el-radio-group v-model="query.isSiteMerge" size="small" @change="getData">
            <el-radio-button :label="true">聚合AQI数据</el-radio-button>
            <el-radio-button :label="false">站点AQI数据</el-radio-button>
          </el-radio-group>

          <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="getData"/>
        </template>

        <sidebar-content sidebarWidth="180px" title="站点选择">
          <template #silder-header-toolbar>
            <select-ctrl-group
              :ids="query.siteIds"
              :options="filterSites"
              show-icon
              style="padding-bottom:0;"
              @change="onSelectCtrlChange"
            />
          </template>

          <template #sidebar-body>
            <div class="device-dropdown-selector-wrapper">
              <div class="device-dropdown-selector-wrapper-inner">
                <el-tree
                  ref="site-tree"
                  :data="filterSites"
                  :props="{
                    value: 'id',
                    label: 'name'
                  }"
                  node-key="id"
                  show-checkbox
                  accordion
                  check-on-click-node
                  :default-checked-keys="query.siteIds"
                  @check="onSiteCheckChange"
                />
                <!-- <div
                  v-for="site in filterSites"
                  :key="site.id"
                  class="device-dropdown-selector"
                >
                  <el-checkbox v-model="query.siteIds" :label="site.id" @change="">{{site.name}}</el-checkbox>
                </div> -->
              </div>
            </div>
          </template>

          <template #sidebar-content-body>
            <data-table
              v-if="query.isSiteMerge"
              ref="dataTable"
              :key="dataTableKey"
              :columns="headerColumns"
              :data="dataList"
              :pagination="pagination"
              :highlight-data-time="''"
              selected-style
            />
            <section class="data-wrapper" v-if="!query.isSiteMerge">
              <section class="site-data">
                <div v-for="(el, index) in siteDataList" :key="index">
                  <div class="site-data-header">
                    <span>{{el.name}}</span>
                  </div>
                  <div class="site-data-body">
                    <data-table
                      ref="dataTables"
                      :key="dataTableKey + index"
                      :columns="headerColumns"
                      :data="el.data"
                      :highlight-data-time="''"
                    />
                  </div>
                </div>
              </section>
            </section>
          </template>
        </sidebar-content>
      </data-wrapper>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DataTable from '../../../../components/Data/DataTable'
import CSVDownloader from '../../../../utils/CSVDownloader'
export default {
  name: 'DataManagementAQIStatisticalReport',
  routeInfo: {
    label: 'AQI数据查询',
    icon: 'fa fa-users'
  },
  extends: BaseFactorData,
  components: {LayoutContent, DataTable},
  data () {
    return {
      options: [{
        value: 1,
        label: '小时'
      }, {
        value: 24,
        label: '日'
      }],
      value: 1,
      query: {
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        granularity: 1,
        isAuditCompleted: false, // finished
        isSiteMerge: true,
        isTimeMerge: false
      },
      flag: {
        merge: true,
        site: false
      },
      tableDataMap: {
        dataTime: '--',
        aqi: '--',
        grade: '--',
        primaryPollutant: '--',
        SO2iaqi: '--',
        SO2value: '--',
        NO2iaqi: '--',
        NO2value: '--',
        COiaqi: '--',
        COvalue: '--',
        O3iaqi: '--',
        O3value: '--',
        PM10iaqi: '--',
        PM10value: '--',
        'PM2.5iaqi': '--',
        'PM2.5value': '--',
        SO2id: '1001',
        SO2name: 'SO2',
        NO2id: '1003',
        NO2name: 'NO2',
        COid: '1005',
        COname: 'CO',
        O3id: '1006',
        O3name: 'O3',
        PM10id: '1007',
        PM10name: 'PM10',
        'PM2.5id': '1008',
        'PM2.5name': 'PM2.5'
      },
      dataTableKey: 0,
      headerColumns: [],
      dataList: [],
      siteDataList: [],
      pagination: {
        no: 1,
        size: 24
      },
      csvData: []
    }
  },
  methods: {
    choiceChange () {
      let {value} = this
      this.query.granularity = value
    },
    handleClick (tab, event) {
      let {flag} = this
      this.query.isSiteMerge = flag[tab.name]
      this.dataList = []
      this.getData()
    },
    getData () {
      this.changeLoadStatus(true)
      this.dataTableKey = 0
      let {query, tableDataMap} = this
      if (query.siteIds.length === 0) {
        this.dataList = []
        this.changeLoadStatus(false)
        return false
      }
      this.$api.Aqi.getAQIData(query).then(backData => {
        if (backData.length === 0) {
          this.dataList = []
          return false
        }

        // grade状态码
        let level = {
          1: '优',
          2: '良',
          3: '轻度污染',
          4: '中度污染',
          5: '重度污染',
          6: '严重污染'
        }

        let dataArr = backData.map(item => {
          const {aqi} = item
          item.primaryPollutant = item.primaryPollutant ? item.primaryPollutant.replaceAll('_24H', '') : '--'

          if (Number.isFinite(aqi)) {
            item.aqi = Math.round(aqi)
            item.grade = level[item.grade]
          } else {
            item.aqi = null
            item.grade = null
          }

          const {pollutantData} = item
          const pollutantDataLen = pollutantData.length

          for (let i = 0; i < pollutantDataLen; i++) {
            const data = pollutantData[i]
            let {rootFactorId} = data

            // if (!/^(PM2\.5|PM10)$/.test(rootFactorId) && this.query.granularity === 1) {
            //   rootFactorId = rootFactorId.replace(/_24H$/, '')
            //   const {value, iaqi} = data
            //   item[rootFactorId + 'id'] = data.factorId
            //   item[rootFactorId + 'name'] = rootFactorId
            //   item[rootFactorId + 'value'] = Number.isFinite(value) ? value.toFixed(3) : null
            //   item[rootFactorId + 'iaqi'] = Number.isFinite(iaqi) ? iaqi.toFixed(2) : null
            // } else {
            //   const {value, iaqi} = data
            //   item[rootFactorId + 'id'] = data.factorId
            //   item[rootFactorId + 'name'] = rootFactorId
            //   item[rootFactorId + 'value'] = Number.isFinite(value) ? value.toFixed(3) : null
            //   item[rootFactorId + 'iaqi'] = Number.isFinite(iaqi) ? iaqi.toFixed(2) : null
            // }
            const {value, iaqi} = data
            item[rootFactorId + 'id'] = data.factorId
            item[rootFactorId + 'name'] = rootFactorId
            item[rootFactorId + 'value'] = Number.isFinite(value) ? value.toFixed(3) : '--'
            item[rootFactorId + 'iaqi'] = Number.isFinite(iaqi) ? iaqi.toFixed(2) : '--'
          }

          return {
            ...tableDataMap,
            ...item,
            dataTime: this.value === 24 ? new Date(item.dataTime).format('YYYY/MM/DD') : item.dataTime
          }
        })

        this.csvData = dataArr

        if (query.isSiteMerge === false) {
          let {filterSiteMap} = this
          this.csvData = dataArr.map(item => {
            return {
              ...filterSiteMap[item.siteId],
              ...item
            }
          })

          let temp = query.siteIds.reduce((map, el) => {
            if (!map[el]) {
              map[el] = {
                id: el,
                data: []
              }
            }

            dataArr.forEach(item => {
              if (el === item.siteId) {
                map[el].data.push(item)
              }
            })

            return map
          }, {})

          dataArr = Object.values(temp).map(item => {
            return {
              ...filterSiteMap[item.id],
              data: Object.values(item.data)
            }
          })
        }

        this.formatData(dataArr)
        this.resetPagination()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData (dataArr) {
      this.dataTableKey++
      let headerColumns = [{
        id: 'dataTime',
        name: '时间',
        width: 180,
        align: 'left',
        fixed: true
      }, {
        id: 'aqi',
        name: 'AQI',
        width: 100,
        align: 'left'
      }, {
        id: 'grade',
        name: '等级',
        width: 100,
        align: 'left'
      }, {
        id: 'primaryPollutant',
        name: '首要污染物',
        width: 150,
        align: 'left'
      }, {
        id: 'SO2iaqi',
        name: 'SO₂(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: 'SO2value',
        name: 'SO₂(μg/m3)',
        width: 120,
        align: 'left'
      }, {
        id: 'NO2iaqi',
        name: 'NO₂(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: 'NO2value',
        name: 'NO₂(μg/m3)',
        width: 120,
        align: 'left'
      }, {
        id: 'PM10iaqi',
        name: 'PM₁₀(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: 'PM10value',
        name: 'PM₁₀(μg/m3)',
        width: 120,
        align: 'left'
      }, {
        id: 'PM2.5iaqi',
        name: 'PM₂.₅(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: 'PM2.5value',
        name: 'PM₂.₅(μg/m3)',
        width: 120,
        align: 'left'
      }, {
        id: 'COiaqi',
        name: 'CO(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: 'COvalue',
        name: 'CO(mg/m3)',
        width: 120,
        align: 'left'
      }, {
        id: this.value === 24 ? 'H8O3iaqi' : 'O3iaqi',
        name: this.value === 24 ? 'O₃_8H(IAQI)' : 'O₃(IAQI)',
        width: 120,
        align: 'left'
      }, {
        id: this.value === 24 ? 'H8O3value' : 'O3value',
        name: this.value === 24 ? 'O₃_8H(μg/m3)' : 'O₃(μg/m3)',
        width: 120,
        align: 'left'
      }]

      this.headerColumns = Object.freeze(headerColumns)

      let {query: {siteIds, isSiteMerge}, filterSiteMap} = this
      if (dataArr.length === 0) {
        this.dataList = []

        this.siteDataList = siteIds.map(item => {
          return {
            name: filterSiteMap[item].name,
            data: []
          }
        })
        return false
      }

      if (isSiteMerge) {
        this.dataList = Object.freeze(dataArr)
      } else {
        this.siteDataList = Object.freeze(dataArr)
      }
    },
    resetPagination () {
      let {pagination, value} = this
      pagination.no = 1
      pagination.size = value === 24 ? 30 : 24
    },
    renderData () {
      this.$nextTick(() => {
        if (this.query.isSiteMerge) {
          this.$refs.dataTable.doLayout()
        } else {
          let dataTables = this.$refs.dataTables
          dataTables.forEach(dataTable => dataTable.doLayout())
        }
      })
    },
    onDownloadBtnClick () {
      let {headerColumns, query: {beginTime, endTime, isSiteMerge}, csvData} = this
      let csvName = `${new Date(beginTime).format('YYYY年MM月DD日')}_${new Date(endTime).format('YYYY年MM月DD日')}AQI数据查询`

      if (isSiteMerge) {
        let data = csvData.map(el => Object.values({
          dataTime: el.dataTime,
          aqi: el.aqi,
          grade: el.grade,
          primaryPollutant: el.primaryPollutant,
          SO2iaqi: el.SO2iaqi,
          SO2value: el.SO2value,
          NO2iaqi: el.NO2iaqi,
          NO2value: el.NO2value,
          PM10iaqi: el.PM10iaqi,
          PM10value: el.PM10value,
          'PM2.5iaqi': el['PM2.5iaqi'],
          'PM2.5value': el['PM2.5value'],
          COiaqi: el.COiaqi,
          COvalue: el.COvalue,
          O3iaqi: this.value === 1 ? el.O3iaqi : el.H8O3iaqi,
          O3value: this.value === 1 ? el.O3value : el.H8O3value
        }))

        let firstColumn = headerColumns.map(el => el.name)

        CSVDownloader([firstColumn, ...data], csvName)
      } else {
        let data = csvData.map(el => Object.values({
          siteName: el.name,
          dataTime: el.dataTime,
          aqi: el.aqi,
          grade: el.grade,
          primaryPollutant: el.primaryPollutant,
          SO2iaqi: el.SO2iaqi,
          SO2value: el.SO2value,
          NO2iaqi: el.NO2iaqi,
          NO2value: el.NO2value,
          PM10iaqi: el.PM10iaqi,
          PM10value: el.PM10value,
          'PM2.5iaqi': el['PM2.5iaqi'],
          'PM2.5value': el['PM2.5value'],
          COiaqi: el.COiaqi,
          COvalue: el.COvalue,
          O3iaqi: this.value === 1 ? el.O3iaqi : el.H8O3iaqi,
          O3value: this.value === 1 ? el.O3value : el.H8O3value
        }))
        let firstColumn = headerColumns.map(el => el.name)
        firstColumn.unshift('站点')

        CSVDownloader([firstColumn, ...data], csvName)
      }
    },
    onSiteCheckChange () {
      let checkedSiteList = this.getSiteTree().getCheckedNodes()
      this.query.siteIds = checkedSiteList.filter(item => !Array.isArray(item.children)).map(item => item.id)
      this.getData()
    },
    setCheckedKeys (siteIds) {
      let factorTree = this.getSiteTree()

      if (factorTree) {
        factorTree.setCheckedKeys(siteIds)
        this.getData()
      }
    },
    getSiteTree () {
      return this.$refs['site-tree']
    },
    onSelectCtrlChange (ids) {
      this.setCheckedKeys(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

.tree-popover-wrapper {
  max-height: 300px;
  overflow: auto;
}

.data-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    height: 400px;
  }
}
.device-dropdown-selector-wrapper {
  display: grid;
  grid-template-rows: max-content auto;
  height: 400px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px 0;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/14AQI-Data/index.vue